import { ReactNode } from "react";
import { useAppSelector } from "../app/hooks";
import { selectRole } from "../app/auth/createAuthSlice";
import { Navigate } from "react-router-dom";
import { RoleName } from "../app/constants/roles";

type Props = {
  allowedRoles: RoleName[];
  children: ReactNode;
};

export default function RequireRole({ allowedRoles, children }: Props) {
  const roles = useAppSelector(selectRole) || [];

  const hasRole = Array.isArray(roles) && roles.some(r => allowedRoles.includes((r as any).roleName));

  if (hasRole) return <>{children}</>;

  return <Navigate to="/unauthorized" replace />;
}
